module.exports = __webpack_public_path__ + "static/media/hmax_15.fd8bd293.jpg";